import { render, staticRenderFns } from "./LifeRemainingBarComponent.vue?vue&type=template&id=531862bf&"
import script from "./LifeRemainingBarComponent.vue?vue&type=script&lang=js&"
export * from "./LifeRemainingBarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports